import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ReportFranchiseProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `Report/GetSelectedFranchises/${props.reportId}`, method: 'GET', secure: true });
    }, [execute]);  

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Report/SetSelectedFranchises/${props.reportId}`, method: 'POST', payload: props.franchises, secure: true });
    }, [execute]);

    const value = { listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useReportFranchiseStore = () => React.useContext(Context);
